module.exports = __webpack_public_path__ + "img/visio.12c000a1.jpg";